import { render, staticRenderFns } from "./tourcategory.vue?vue&type=template&id=0b0eebb0&scoped=true&"
import script from "./tourcategory.vue?vue&type=script&lang=js&"
export * from "./tourcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0eebb0",
  null
  
)

export default component.exports